import moment from "moment-timezone";
import { IStatusEvent } from "../../../core/api/objects/types";
import useTranslations from "../../../core/i18n/useTranslations";
import Table from "../../../ui-lib/components/Tables/Table";
import TableCell from "../../../ui-lib/components/Tables/TableCell";
import useUser from "../../../core/user/useUser";
import Badge, { BadgeProps } from "../../../ui-lib/components/Badges/Badge";
import { errorStatuses } from "./PlanningOverview/PlanningOverview";
import { Spacer } from "../../../components/Layout/Layout";
import Divider from "../../../ui-lib/components/Divider/Divider";
import { userDateFormat } from "../../../ui-lib/utils/userDateFormat";

const columns = (
  t: (key: string) => string,
  settings: { dateFormat: string; timezone: string },
) => [
  {
    key: "created_when",
    header: t("Common:when"),
    fieldTemplate: (rowData: IStatusEvent) => {
      return (
        <TableCell
          value={moment
            .utc(rowData.timestamp)
            .tz(settings.timezone)
            .format(`${userDateFormat(settings.dateFormat)} HH:mm`)}
        />
      );
    },
  },
  {
    key: "cerated_by",
    header: t("Common:created_by"),
    fieldTemplate: (rowData: IStatusEvent) => (
      <TableCell value={rowData.admin} />
    ),
  },
  {
    key: "status",
    header: t("Common:status"),
    fieldTemplate: (rowData: IStatusEvent) => {
      let statusVariant = "success";
      if (errorStatuses.includes(rowData.status)) statusVariant = "error";
      if (
        !errorStatuses.includes(rowData.status) &&
        rowData.status !== "Complete"
      )
        statusVariant = "info";
      return (
        <Badge
          withHighlightedText
          variant={statusVariant as BadgeProps["variant"]}
          title={t(`Objects:${rowData.status}`)}
        />
      );
    },
  },
];

export const CurrentActivityHistory = ({
  statuses = [],
}: {
  statuses: IStatusEvent[];
}) => {
  const t = useTranslations();
  const { config } = useUser();
  const settings = {
    dateFormat: config?.dateFormat ?? "DD/MM/YYYY",
    timezone: config?.timezone.timezoneName ?? "Europe/Stockholm",
  };
  return (
    <>
      <Spacer size={8} />
      <Divider />
      <Spacer size={16} />
      <h2>{t("Objects:history_of_current_activity")}</h2>
      <Spacer size={8} />
      <p>{t("Objects:history_of_current_activity_description")}</p>
      <Spacer size={16} />
      <Table<IStatusEvent>
        hideEmptyMessage
        columns={columns(t, settings)}
        items={statuses}
      />
    </>
  );
};
